// Define the type for corner_radius
type corner_radius_keys =
  | 'rounded-sm'
  | 'rounded'
  | 'rounded-md'
  | 'rounded-lg';
type spacing_keys =
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '8'
  | '9'
  | '10'
  | '12'
  | '14'
  | '16';

export const corner_radius: Record<corner_radius_keys, number> = {
  'rounded-sm': 2,
  rounded: 4,
  'rounded-md': 6,
  'rounded-lg': 8,
};

// Define the type for spacing
export const spacing: Record<spacing_keys, number> = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  9: 36,
  10: 40,
  12: 48,
  14: 56,
  16: 64,
};
